package flagpack.icons.medium

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Tajikistan Flag (20x15dp)
 *
 * - ISO Alpha-2: TJ
 * - ISO Alpha-3: TJK
 * - ISO Numeric: 762
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Medium.Tajikistan: ImageVector by lazy {
    ImageVector.Builder(
        name = "Tajikistan:TJ:TJK:762:Medium",
        defaultWidth = 20.dp,
        defaultHeight = 15.dp,
        viewportWidth = 20f,
        viewportHeight = 15f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(20f)
                verticalLineToRelative(15f)
                horizontalLineToRelative(-20f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(20f)
                verticalLineToRelative(15f)
                horizontalLineToRelative(-20f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                horizontalLineTo(20f)
                verticalLineTo(15f)
                horizontalLineTo(0f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFC51918)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                verticalLineTo(5f)
                horizontalLineTo(20f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF409100)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 10f)
                verticalLineTo(15f)
                horizontalLineTo(20f)
                verticalLineTo(10f)
                horizontalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFFBB00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(10.013f, 5.394f)
                lineTo(9.643f, 5.655f)
                lineTo(9.773f, 5.217f)
                lineTo(9.415f, 4.941f)
                lineTo(9.865f, 4.932f)
                lineTo(10.013f, 4.5f)
                lineTo(10.16f, 4.932f)
                lineTo(10.61f, 4.941f)
                lineTo(10.252f, 5.217f)
                lineTo(10.382f, 5.655f)
                lineTo(10.013f, 5.394f)
                close()
                moveTo(8.452f, 5.777f)
                lineTo(8.082f, 6.038f)
                lineTo(8.213f, 5.6f)
                lineTo(7.854f, 5.324f)
                lineTo(8.304f, 5.315f)
                lineTo(8.452f, 4.883f)
                lineTo(8.6f, 5.315f)
                lineTo(9.05f, 5.324f)
                lineTo(8.691f, 5.6f)
                lineTo(8.821f, 6.038f)
                lineTo(8.452f, 5.777f)
                close()
                moveTo(6.869f, 7.187f)
                lineTo(7.238f, 6.926f)
                lineTo(7.608f, 7.187f)
                lineTo(7.477f, 6.749f)
                lineTo(7.836f, 6.473f)
                lineTo(7.386f, 6.464f)
                lineTo(7.238f, 6.032f)
                lineTo(7.09f, 6.464f)
                lineTo(6.64f, 6.473f)
                lineTo(6.999f, 6.749f)
                lineTo(6.869f, 7.187f)
                close()
                moveTo(6.848f, 8.415f)
                lineTo(6.478f, 8.676f)
                lineTo(6.609f, 8.238f)
                lineTo(6.25f, 7.962f)
                lineTo(6.7f, 7.953f)
                lineTo(6.848f, 7.521f)
                lineTo(6.996f, 7.953f)
                lineTo(7.446f, 7.962f)
                lineTo(7.087f, 8.238f)
                lineTo(7.217f, 8.676f)
                lineTo(6.848f, 8.415f)
                close()
                moveTo(12.764f, 8.676f)
                lineTo(13.134f, 8.415f)
                lineTo(13.503f, 8.676f)
                lineTo(13.373f, 8.238f)
                lineTo(13.732f, 7.962f)
                lineTo(13.282f, 7.953f)
                lineTo(13.134f, 7.521f)
                lineTo(12.986f, 7.953f)
                lineTo(12.536f, 7.962f)
                lineTo(12.895f, 8.238f)
                lineTo(12.764f, 8.676f)
                close()
                moveTo(12.657f, 6.926f)
                lineTo(12.288f, 7.187f)
                lineTo(12.418f, 6.749f)
                lineTo(12.059f, 6.473f)
                lineTo(12.509f, 6.464f)
                lineTo(12.657f, 6.032f)
                lineTo(12.805f, 6.464f)
                lineTo(13.255f, 6.473f)
                lineTo(12.896f, 6.749f)
                lineTo(13.027f, 7.187f)
                lineTo(12.657f, 6.926f)
                close()
                moveTo(11.092f, 6.038f)
                lineTo(11.461f, 5.777f)
                lineTo(11.831f, 6.038f)
                lineTo(11.7f, 5.6f)
                lineTo(12.059f, 5.324f)
                lineTo(11.609f, 5.315f)
                lineTo(11.461f, 4.883f)
                lineTo(11.314f, 5.315f)
                lineTo(10.864f, 5.324f)
                lineTo(11.222f, 5.6f)
                lineTo(11.092f, 6.038f)
                close()
                moveTo(7.917f, 10.472f)
                lineTo(7.802f, 10.061f)
                curveTo(8.439f, 9.889f, 9.171f, 9.803f, 9.998f, 9.803f)
                curveTo(10.824f, 9.803f, 11.556f, 9.889f, 12.194f, 10.061f)
                lineTo(12.078f, 10.472f)
                curveTo(11.481f, 10.31f, 10.787f, 10.229f, 9.998f, 10.229f)
                curveTo(9.208f, 10.229f, 8.515f, 10.31f, 7.917f, 10.472f)
                close()
                moveTo(8.707f, 9.814f)
                curveTo(8.452f, 9.857f, 8.244f, 9.611f, 8.244f, 9.611f)
                lineTo(8.497f, 9.507f)
                curveTo(8.489f, 9.332f, 8.594f, 9.223f, 8.594f, 9.223f)
                curveTo(8.679f, 9.263f, 8.796f, 9.478f, 8.796f, 9.478f)
                horizontalLineTo(9.025f)
                curveTo(9.025f, 9.478f, 8.961f, 9.771f, 8.707f, 9.814f)
                close()
                moveTo(11.713f, 9.654f)
                curveTo(11.713f, 9.654f, 11.505f, 9.899f, 11.25f, 9.856f)
                curveTo(10.996f, 9.813f, 10.932f, 9.52f, 10.932f, 9.52f)
                horizontalLineTo(11.161f)
                curveTo(11.161f, 9.52f, 11.277f, 9.305f, 11.363f, 9.266f)
                curveTo(11.363f, 9.266f, 11.468f, 9.374f, 11.46f, 9.549f)
                lineTo(11.713f, 9.654f)
                close()
                moveTo(9.966f, 9.736f)
                curveTo(9.708f, 9.743f, 9.536f, 9.471f, 9.536f, 9.471f)
                lineTo(9.801f, 9.403f)
                curveTo(9.817f, 9.228f, 9.937f, 9.136f, 9.937f, 9.136f)
                curveTo(10.016f, 9.186f, 10.101f, 9.415f, 10.101f, 9.415f)
                lineTo(10.328f, 9.447f)
                curveTo(10.328f, 9.447f, 10.224f, 9.728f, 9.966f, 9.736f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFFBB00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(9.974f, 8.562f)
                curveTo(9.974f, 8.562f, 9.681f, 9.232f, 9.219f, 9.284f)
                curveTo(8.758f, 9.336f, 8.523f, 8.903f, 8.523f, 8.903f)
                curveTo(8.523f, 8.903f, 8.493f, 9.354f, 7.945f, 9.527f)
                curveTo(7.396f, 9.701f, 7.108f, 9.007f, 7.108f, 9.007f)
                curveTo(7.108f, 9.007f, 7.393f, 9.262f, 7.836f, 9.151f)
                curveTo(8.279f, 9.04f, 8.453f, 8.629f, 8.453f, 8.629f)
                curveTo(8.453f, 8.629f, 8.781f, 9.057f, 9.219f, 8.843f)
                curveTo(9.658f, 8.629f, 9.9f, 8.367f, 9.9f, 8.116f)
                verticalLineTo(7.365f)
                curveTo(9.9f, 7.365f, 9.787f, 7.17f, 9.591f, 7.17f)
                curveTo(9.395f, 7.17f, 9.34f, 7.308f, 9.34f, 7.308f)
                curveTo(9.34f, 7.308f, 9.263f, 6.527f, 9.969f, 6.478f)
                lineTo(9.969f, 6.476f)
                lineTo(9.988f, 6.477f)
                lineTo(10.008f, 6.476f)
                lineTo(10.008f, 6.478f)
                curveTo(10.714f, 6.527f, 10.637f, 7.308f, 10.637f, 7.308f)
                curveTo(10.637f, 7.308f, 10.582f, 7.17f, 10.386f, 7.17f)
                curveTo(10.19f, 7.17f, 10.077f, 7.365f, 10.077f, 7.365f)
                verticalLineTo(8.116f)
                curveTo(10.077f, 8.367f, 10.319f, 8.629f, 10.758f, 8.843f)
                curveTo(11.196f, 9.057f, 11.524f, 8.629f, 11.524f, 8.629f)
                curveTo(11.524f, 8.629f, 11.698f, 9.04f, 12.141f, 9.151f)
                curveTo(12.584f, 9.262f, 12.869f, 9.007f, 12.869f, 9.007f)
                curveTo(12.869f, 9.007f, 12.581f, 9.701f, 12.032f, 9.527f)
                curveTo(11.484f, 9.354f, 11.454f, 8.903f, 11.454f, 8.903f)
                curveTo(11.454f, 8.903f, 11.219f, 9.336f, 10.758f, 9.284f)
                curveTo(10.296f, 9.232f, 10.003f, 8.562f, 10.003f, 8.562f)
                lineTo(9.988f, 7.676f)
                lineTo(9.974f, 8.562f)
                close()
                moveTo(9.968f, 6.689f)
                curveTo(9.642f, 6.689f, 9.576f, 6.964f, 9.576f, 6.964f)
                curveTo(9.863f, 6.964f, 9.968f, 7.089f, 9.968f, 7.089f)
                curveTo(9.968f, 7.089f, 10.18f, 6.964f, 10.394f, 6.964f)
                curveTo(10.394f, 6.964f, 10.293f, 6.689f, 9.968f, 6.689f)
                close()
            }
        }
    }.build()
}

@Preview
@Composable
private fun TajikistanPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Medium.Tajikistan,
            contentDescription = "Tajikistan Flag"
        )
    }
}
